import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { UseFormSetError } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../hooks/useGetHook";
import usePatchHook from "../../hooks/usePatchHook";
import CreateIcon from "../../icons/CreateIcon";
import Spinner from "../../shared/Spinner";
import { IPage } from "../../types/interface";

const EditPageComponent = loadable(() => import("../../components/Pages/Edit"));

export default function EditPages() {
  const { id } = useParams();

  const { data: pageInfo, isLoading: isGettingPageInfo } = useGetHook<IPage>({
    url: `${APIS.PAGE}${id}`,
    queryKey: [`get-page-details-${id}`],
  });

  const { mutateAsync: updatePage, isLoading: isUpdatingPage } = usePatchHook({
    queryKey: [`update-page-details-${id}`],
    navigateURL: "/website-builder/pages",
  });

  const handleUpdate = async (
    data: IPage,
    setError: UseFormSetError<IPage>
  ): Promise<void> => {
    try {
      const url = `${APIS.PAGE}${id}/`;
      await updatePage({
        url,
        formData: {
          ...data,
          popup_pages: data?.popup_pages?.map((pp) => pp.value),
          html_content: data?.page_contents?.html_content,
          css_content: data?.page_contents?.css_content,
          project_data: data?.page_contents?.project_data,
        },
        setError,
      });
    } catch (error) {
      if (error instanceof Error) toast.error(error.message);
    }
  };

  return (
    <>
      {isGettingPageInfo ? (
        <Spinner />
      ) : (
        <EditPageComponent
          handleUpdate={handleUpdate}
          isUpdatingPage={isUpdatingPage}
          pageInfo={pageInfo}
        />
      )}
    </>
  );
}
